import { render, staticRenderFns } from "./VideoArchiveComponent.vue?vue&type=template&id=4feee4d1&scoped=true&"
import script from "./VideoArchiveComponent.vue?vue&type=script&lang=js&"
export * from "./VideoArchiveComponent.vue?vue&type=script&lang=js&"
import style0 from "./VideoArchiveComponent.vue?vue&type=style&index=0&id=4feee4d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feee4d1",
  null
  
)

export default component.exports